import React, { useState } from 'react';

import config from '../config';
let providerSearchTimeout;

function MeConnectorProviderList({ providers, connectors, show, onSubmit }) {
	const [ state, setState ] = useState({});

	const onSearch = value => {
		providerSearchTimeout && clearTimeout(providerSearchTimeout);

		providerSearchTimeout = setTimeout(() => {
			setState(s => ({...s, providerSearchRegex: value ? new RegExp(value, 'i') : undefined}));
			value && window.mixpanel?.people.set({broker_search: value});
		}, 555);
	};

	const connectorsProviderNames = connectors?.map(item => item.providerName) || [];
	const providersKeys = Object.keys(providers).filter(providerName => providers[providerName].status);

	return connectors && (
		<div>
			<p>Select a broker or service to connect:</p>

			<div className="input-group">
				<span className="input-group-text" id="providerSearch"><img src="/static/images/icons/search.svg" /></span>
				<input onChange={event => onSearch(event.target.value)} type="text" className="form-control" placeholder="Start typing to filter..." />
			</div>

			{
				show && ( // weak: to not preload images for "collapsed" view
					<div className="container-fluid text-center mt-3">
						<div className="row row-cols-2 row-cols-md-3 row-cols-xl-3 g-3 mx-n3">
							{
								providersKeys.filter(item => !state.providerSearchRegex || providers[item].title.match(state.providerSearchRegex)).map(item => (
									<div key={item} data-bs-toggle="collapse" data-bs-target="#providerList">
										<div
											onClick={onSubmit.bind(null, providers[item])}
											role="button"
											className="col hover"
											data-bs-toggle="modal"
											data-bs-target="#connectorCreateModal"
										>
											<div className={`border rounded-1 p-2 bg-light bg-opacity-10 hover-opacity-100 ${connectorsProviderNames.includes(item) ? 'border-success' : ''}`}>
												<div className="mx-2 my-3"><img src={`/static/images/providers/${item}.svg`} alt={providers[item].title} className="img-fluid" style={{height: '' + (config.provider.scales[item] || 1) * 2.2 + 'em', marginTop: '' + (1 - (config.provider.scales[item] || 1)) * 2.2 / 2 + 'em', marginBottom: '' + (1 - (config.provider.scales[item] || 1)) * 2.2 / 2 + 'em'}} /></div>
												{ /* <div>{providers[item].title}</div> */ }
												<div className="text-secondary text-truncate"><small>{providers[item].reference?.class?.values.map(classItem => config.order.class.labels[classItem]).join(' \u2022 ')}</small></div>
											</div>
										</div>
									</div>
								))
							}
						</div>
					</div>
				)
			}

			<div className="mt-3">&nbsp;</div>
		</div>
	);
}

export default MeConnectorProviderList;
